import { useEffect, useState } from 'react';
import { Menu, MenuButton, MenuItem, MenuList, IconButton } from '@airbus/components-react';
import { MoreVert } from '@airbus/icons/react';
import { useColumnContextAPI } from '../context/GetAllColumnContext';
import styles from './TabMenu.module.css';
export default function TabMenu({ tabMenu }) {
  const [value, setValue] = useState(null);
  const { updateTabMenuDetails, updateRightTabMenuDetails, rightPanelTabMenu } =
    useColumnContextAPI();
  const handleClick = (tabValue) => {
    updateTabMenuDetails(tabValue);
    setValue(tabValue);
    updateRightTabMenuDetails(tabValue);
  };

  useEffect(() => {
    if (rightPanelTabMenu >= 0) {
      setValue(rightPanelTabMenu);
    }
  }, [rightPanelTabMenu]);
  return (
    <Menu>
      <MenuButton variant='ghost' size='small' component={IconButton}>
        <MoreVert />
      </MenuButton>
      <MenuList className={styles.tabMenuHeight}>
        {tabMenu.length &&
          tabMenu.map(({ label }, event) => (
            <MenuItem
              key={`label_${label.replace(/\s/g, '')}`}
              onClick={() => handleClick(event)}
              quiet={value === event}
              selected={value === event}
              className={`${value === event ? 'active' : ''}`}
            >
              {label}
            </MenuItem>
          ))}
      </MenuList>
    </Menu>
  );
}
